<template>
    <component :is="template">
        <div class="gift">
            <div>
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">캐시선물내역</h2>
                </div>

                <div>
                    <div class="mb-30px mb-md-40px">
                        <v-layout>
                            <v-btn :color="filter.type == 'give' ? 'primary' : 'grey'" :outlined="filter.type == 'give' ? false : true" x-large tile dark elevation="0" class="col-6" @click="filter.type = 'give'; search(true);">보낸내역</v-btn>
                            <v-btn :color="filter.type == 'take' ? 'primary' : 'grey'" :outlined="filter.type == 'take' ? false : true" x-large tile dark elevation="0" class="col-6" @click="filter.type = 'take'; search(true);">받은내역</v-btn>
                        </v-layout>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <div>
                    <div class="mb-4">
                        <v-row class="row--small">
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 150">
                                    <v-select v-model="filter.status" :items="statuses" item-text="text" item-value="value" label="상태" persistent-placeholder outlined dense hide-details color="primary" @input="page = 1; search(true)"/>
                                </v-sheet>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 150">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field :value="filter.createdAt[0]" append-icon="event" label="시작일" readonly persistent-placeholder outlined dense hide-details color="primary" v-on="on" @click:append="filter.createdAt[0] = ''; page = 1; search(true)"/>
                                        </template>
                                        <v-date-picker v-model="filter.createdAt[0]" type="date" no-title scrollable min="2010-01-01" max="2060-12-31" class="w-100" @input="page = 1; search(true)"/>
                                    </v-menu>
                                </v-sheet>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 150">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field :value="filter.createdAt[1]" append-icon="event" label="종료일" readonly persistent-placeholder outlined dense hide-details color="primary" v-on="on" @click:append="filter.createdAt[1] = ''; page = 1; search(true)"/>
                                        </template>
                                        <v-date-picker v-model="filter.createdAt[1]" type="date" no-title scrollable min="2010-01-01" max="2060-12-31" class="w-100" @input="page = 1; search(true)"/>
                                    </v-menu>
                                </v-sheet>
                            </v-col>
                            <v-spacer/>
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' :180">
                                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder outlined dense hide-details color="primary" @input="filter.searchValue = null"/>
                                </v-sheet>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder outlined dense hide-details append-icon="mdi-magnify" color="primary" :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);" @click:append="page = 1; search(true);"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-if="filter.type == 'take'">
                        <v-row>
                            <v-col align="right">
                                <v-btn color="white" elevation="1" class="green--text px-2 mr-1" @click="excel">
                                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                                </v-btn>
                                <v-btn v-if="showsPushButton" color="white" elevation="1" class="primary--text px-2 mr-1" :loading="pushLoading" :disabled="pushLoading" @click="enablePush">
                                    <v-icon class="mr-2">mdi-bell-ring-outline</v-icon>{{ pushTexts.button }}
                                </v-btn>
                                <v-btn v-if="showsPushOffButton" color="white" elevation="1" class="grey--text text--darken-1 px-2 mr-1" :loading="pushLoading" :disabled="pushLoading" @click="disablePush">
                                    <v-icon class="mr-2">mdi-bell-off-outline</v-icon>{{ pushTexts.offButton }}
                                </v-btn>
                                <v-btn color="primary" :loading="loading" :disabled="loading" @click="allTake">모두받기</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider/>
                    <v-data-table :items="gifts" :headers="giftsHeaders" hide-default-footer disable-pagination disable-sort class="v-data-table--sm">
                        <span slot="item.sender" slot-scope="{item}">{{ item.sender.name }}({{ item.sender.username }})</span>
                        <span slot="item.receiver" slot-scope="{item}">{{ item.receiver.name }}({{ item.receiver.username }})</span>
                        <span slot="item.amount" slot-scope="{item}">{{ item.amount.format() }}</span>

                        <v-btn slot="item.resend" slot-scope="{item}" small block color="primary" @click="resend(item)" :disabled="loading || item.status != `발송` || item.smsLimit <= item.smsCount">재발송 ({{ item.smsCount }}/{{ item.smsLimit }})</v-btn>
                        <v-btn slot="item.cancel" slot-scope="{item}" small block color="primary" @click="cancel(item)" :disabled="loading || [`취소`,`받음`,`거절`].includes(item.status)">선물취소</v-btn>
                        <v-btn slot="item.take" slot-scope="{item}" small block color="primary" @click="take(item)" :disabled="loading || item.status != `발송`">받기</v-btn>
                        <v-btn slot="item.reject" slot-scope="{item}" small block color="primary" @click="reject(item)" :disabled="loading || item.status != `발송`">거절</v-btn>

                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                    </v-data-table>
                </div>
            </div>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import XLSX from "xlsx";
import { isSupported as isPushSupported, pushState, enableWithAlert as enablePushWithAlert, disable as disablePushToken, PUSH_TEXTS } from "@/plugins/push";
export default {
    data(){
        return {
            filter: {
                type: this.$route.query.type ?? "give",
                status: null,
                createdAt: [ this.$route.query.createdAt?.[0] || "", this.$route.query.createdAt?.[1] || "" ],
                searchKey: null,
                searchValue: null,
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            // 받기/모두받기/취소/거절/재발송 처리중 여부. 연타로 같은 요청이 겹치면
            // 서버에서 중복 수령 경합이 생기므로, 처리중에는 버튼을 잠근다.
            loading: false,

            gifts: [],

            // 선물 알림(웹 푸시) 허용 버튼
            pushSupported: isPushSupported(),
            pushTexts: PUSH_TEXTS,
            pushLoading: false,

            statuses: [
                { text: ":: 전체상태 ::", value: null },
                { text: "발송", value: "발송" },
                { text: "받음", value: "받음" },
                { text: "취소", value: "취소" },
            ],
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); },
        // 권한은 push.js 의 공유 상태를 읽는다(띠에서 허용해도 바로 사라지게). 차단했어도 보여 준다: 누르면 브라우저 설정 안내가 뜬다(PUSH_TEXTS.denied)
        pushPermission(){
            return pushState.permission;
        },
        // 허용 전·차단, 또는 허용했지만 이 기기에서 취소했으면 "알림 받기"
        showsPushButton(){
            return this.pushSupported && (this.pushPermission != "granted" || pushState.optedOut);
        },
        // 허용해서 받고 있으면 "알림 받기 취소"
        showsPushOffButton(){
            return this.pushSupported && this.pushPermission == "granted" && !pushState.optedOut;
        },
        giftsHeaders(){
            switch(this.filter.type){
                case "give": {
                    return [
                        { text: "받는사람", value: "receiver", align: "center", width: 140 },
                        { text: "연락처", value: "receiver.phone", align: "center" },
                        { text: "선물금액", value: "amount", align: "center" },
                        { text: "선물상태", value: "status", align: "center" },
                        { text: "발송일자", value: "createdAt", align: "center" },
                        { text: "재발송", value: "resend", align: "center" },
                        { text: "취소", value: "cancel", align: "center" },
                    ];
                }
                case "take": {
                    return [
                        { text: "보낸사람", value: "sender", align: "center", width: 140 },
                        { text: "연락처", value: "sender.phone", align: "center" },
                        { text: "선물금액", value: "amount", align: "center" },
                        { text: "선물상태", value: "status", align: "center" },
                        { text: "받은일자", value: "createdAt", align: "center" },
                        { text: "받기", value: "take", align: "center" },
                        { text: "거절", value: "reject", align: "center" }
                    ];
                }
            }
        },

        searchKeys(){
            switch(this.filter.type){
                case "give": {
                    return [
                        { text: ":: 전체검색 ::", value: null },
                        { text: "받는사람 이름", value: "receiver.name" },
                        { text: "받는사람 아이디", value: "receiver.username" },
                        { text: "받는사람 연락처", value: "receiver.phone" },
                    ];
                }
                case "take": {
                    return [
                        { text: ":: 전체검색 ::", value: null },
                        { text: "보낸사람 이름", value: "sender.name" },
                        { text: "보낸사람 아이디", value: "sender.username" },
                        { text: "보낸사람 연락처", value: "sender.phone" },
                    ]
                }
            }
        }
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;

            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, gifts } = await api.v1.me.gifts.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.gifts = gifts;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        /**
         * 선물 상태를 바꾸는 요청을 중복 없이 한 번만 보낸다.
         *
         * 처리중에 버튼이 다시 눌리면(연타/더블탭) 같은 선물에 대한 요청이 동시에 날아가
         * 서버에서 수령 경합이 생기므로, 앞선 요청이 끝날 때까지 무시한다.
         *
         * @param {() => Promise<void>} action
         */
        async submit(action){
            if(this.loading) return;
            this.loading = true;
            try{
                await action();
            }
            finally{
                this.loading = false;
            }
        },

        async resend(gift){
            await this.submit(async () => {
                await api.v1.me.gifts.resend(gift);
                await this.$alert("재발송 되었습니다");
                this.search(false);
            });
        },

        async cancel(gift){
            if(await this.$confirm("취소하시겠습니까?")){
                await this.submit(async () => {
                    await api.v1.me.gifts.cancel(gift);
                    await this.$alert("취소 되었습니다");
                    this.search(false);
                });
            }
        },

        async reject(gift){
            if(await this.$confirm("선물을 거절하시겠습니까?")){
                await this.submit(async () => {
                    await api.v1.me.gifts.reject(gift);
                    await this.$alert("선물 거절하기가 완료되었습니다");
                    this.search(false);
                });
            }
        },

        async take(gift){
            if(await this.$confirm("선물을 받으시겠습니까?")){
                await this.submit(async () => {
                    await api.v1.me.gifts.take(gift);
                    await this.$alert("선물받기가 완료되었습니다");
                    this.search(false);
                });
            }
        },

        async allTake(){
            if(await this.$confirm("모든 선물을 받으시겠습니까?")){
                await this.submit(async () => {
                    await api.v1.me.gifts.allTake();
                    await this.$alert("선물받기가 완료되었습니다");
                    this.search(false);
                });
            }
        },

        async excel(){
            if(this.filter.type != "take") return;

            let { gifts } = await api.v1.me.gifts.gets({
                headers: {
                    limit: 0
                },
                params: this.filter
            });

            let rows = [];
            gifts.forEach(gift => {
                rows.push({
                    "보낸사람": `${gift.sender.name}(${gift.sender.username})`,
                    "연락처": gift.sender.phone,
                    "선물금액": gift.amount,
                    "선물상태": gift.status,
                    "받은일자": this.$dayjs(gift.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "받은 캐시선물내역.xlsx");
        },

        async enablePush(){
            if(this.pushLoading) return;
            this.pushLoading = true;
            // enablePushWithAlert 가 권한 요청을 동기로 먼저 부른다. 이 앞에 await 를 두지 않는다
            await enablePushWithAlert(this.$alert);
            this.pushLoading = false;
        },

        async disablePush(){
            if(this.pushLoading) return;
            if(!await this.$confirm(this.pushTexts.offConfirm)) return;
            this.pushLoading = true;
            try{
                await disablePushToken();
            }
            finally{
                this.pushLoading = false;
            }
            await this.$alert(this.pushTexts.off);
        },

    },
    watch: {
        "$route.query.type"() {
            this.init().then(this.search);
        },
    },
    mounted() {
        this.init();
    },
}
</script>